/**
 * @file     CuratedBreadcrumb.tsx
 * @purpose  The visible breadcrumb for a curated listing (Home, Properties,
 *           the address) through the hub Breadcrumb. A client boundary,
 *           because the hub breadcrumb hands next/link to MUI as a component
 *           prop, which a Server Component cannot pass.
 */
'use client';

import { Breadcrumb, toBreadcrumbItems } from '@/components/hub/Breadcrumb';

export function CuratedBreadcrumb({ title }: { title: string }) {
  return (
    <Breadcrumb
      items={toBreadcrumbItems([
        { label: 'Home', href: '/' },
        { label: 'Properties', href: '/properties' },
        { label: title },
      ])}
    />
  );
}
